/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_LabelInputs */

const en_price_page_policy_label = /** @type {(inputs: Price_Page_Policy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellation rules`)
};

const pl_price_page_policy_label = /** @type {(inputs: Price_Page_Policy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zasady odwołania`)
};

/**
* | output |
* | --- |
* | "Cancellation rules" |
*
* @param {Price_Page_Policy_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_label = /** @type {((inputs?: Price_Page_Policy_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_label(inputs)
	return en_price_page_policy_label(inputs)
});